import React, { useState, useEffect } from "react";

import Select from "react-select";
import CustomSelectInput from "../../../components/common/CustomSelectInput";
import axios from "axios";
import { END_POINT } from "../../../constants/defaultValues";

const ShiftSelect = ({ value, onChange, disabled = false }) => {
  const [shifts, setShifts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Load shifts từ API khi mount
  useEffect(() => {
    loadShifts();
  }, []);

  const loadShifts = async () => {
    try {
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.get(`${END_POINT}/user-staff/settings`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (
        response.data &&
        response.data.data &&
        response.data.data.staff_shifts
      ) {
        // Chuyển đổi shifts thành options cho Select
        const shiftOptions = response.data.data.staff_shifts.map(
          (shift, index) => ({
            label: `${shift.name} (${shift.start} - ${shift.end})`,
            value: `${shift.start}-${shift.end}`,
            name: shift.name,
            start: shift.start,
            end: shift.end,
          })
        );
        setShifts(shiftOptions);
      }
    } catch (err) {
      console.error("Error loading shifts:", err);
      // Fallback to default shifts
      setShifts([
        {
          label: "Ca 1 (07:00 - 11:00)",
          value: "07:00-11:00",
          start: "07:00",
          end: "11:00",
        },
        {
          label: "Ca 2 (13:00 - 17:00)",
          value: "13:00-17:00",
          start: "13:00",
          end: "17:00",
        },
        {
          label: "Ca 3 (17:00 - 21:00)",
          value: "17:00-21:00",
          start: "17:00",
          end: "21:00",
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  // Chuyển đổi value (array of {start, end, hash}) thành selected options
  const getSelectedValues = () => {
    if (!value || !Array.isArray(value) || value.length === 0) return [];

    return value.map((v) => {
      const found = shifts.find((s) => s.start === v.start && s.end === v.end);
      if (found) return found;
      return {
        label: `${v.start} - ${v.end}`,
        value: `${v.start}-${v.end}`,
        start: v.start,
        end: v.end,
      };
    });
  };

  // Handle selection change
  const handleChange = (selectedOptions) => {
    // Chuyển đổi selected options thành format working_hours
    const workingHours = selectedOptions
      ? selectedOptions.map((opt, idx) => ({
          hash: `shift_${idx}_${Date.now()}`,
          start: opt.start,
          end: opt.end,
        }))
      : [];

    onChange(workingHours);
  };

  if (loading) {
    return (
      <div className="d-flex align-items-center">
        <span className="text-muted">Đang tải ca làm việc...</span>
      </div>
    );
  }

  return (
    <div>
      <Select
        components={{ Input: CustomSelectInput }}
        className="react-select"
        classNamePrefix="react-select"
        placeholder="Chọn ca làm việc..."
        options={shifts}
        value={getSelectedValues()}
        onChange={handleChange}
        isMulti
        isDisabled={disabled}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
      />
    </div>
  );
};

export default ShiftSelect;
